<template>
    <div>
        <div v-if="isDocsModalOpen" @click="closeModaldocs" class="modal-docs-overlay">
            <div class="modal-docs" @click.stop>
                <div class="modal-docs-header d-block">
                <div class="pb-2" style="color: #D93051;">
                    <i class="no no-c-warning pr-1" style="color: #D93051;"></i>
                    Documentos necessários
                </div>

                <div >Em determinado ponto do formulário, será necessário enviar comprovantes e documentos. Veja aqui a lista para ter em mãos antes de começar a preencher seus dados:</div>
                </div>

                <div class="modal-docs-body">
                    <div style="font-size: 17px; font-weight: 600; padding-bottom: 10px;">Documentos Básicos:</div>

                    <div class="d-block" style="font-size: 14px;">
                        • Cópia do RG </br>
                        • Cópia do CPF </br>
                        • Cópia da CNH (se possível) </br>
                        • Comprovante de residência </br>
                        • Termo de Reconhecimento de riscos inerentes às atividades de passeios em área natural aberta no PNCD</br>
                        • Certidão negativada de mandato judicial de prisão</br>
                        • Declaração de Compromisso</br>
                    </div>

                    <div style="font-size: 17px; font-weight: 600; padding-bottom: 10px; padding-top: 20px;">Cursos / Certificados:</div>

                    <div class="d-block" style="font-size: 14px;">
                        • ICMBio - PNCD</br>
                        • CMC </br>
                        • Quaisquer comprovantes de cursos (Primeiros Socorros, Resgate Aquático etc.) </br>
                        • Comprovante de Escolaridade </br>
                        • Comprovante de Especialização (se houver)</br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: '',

    components:{

    },

    props:{
        isDocsModalOpen: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
      ...mapGetters('', { 

        }),
        
    },

    watch: {
        
    },

    data() {
        return {

        }
    },

    methods: {
        ...mapActions('', [

        ]),

        closeModaldocs(){
            this.$emit("closeModaldocs")
        },
        
    },

    mounted(){

    },

}
</script>

<style>
    .open-modal-docs-text {
        color: #dc4260;
        cursor: pointer;
        font-size: 16px;
    }

    .open-modal-docs-text:hover {
        color: #952239;
        text-decoration: underline;
    }

    .modal-docs-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }

    .modal-docs {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 20px;
        width: 50vw;
        background: white;
        border-radius: 8px;
        overflow: hidden;
        display: block;
        height: fit-content;
    }

    .modal-docs-header {
        padding: 15px;
        padding-bottom: 0;
        font-size: 18px;
    }

    .modal-docs-body {
        font-size: 16px;
        max-height: 80vh;
        overflow-y: auto;
        display: block;
        padding: 1rem;
    }

@media screen and (max-width: 600px) {

.modal-docs{
    position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 20px;
        width: 85vw;

}
}
</style>